import React, { Component } from 'react';
import './EnterpriseSidebarItem.css';
import PropTypes from 'prop-types';

class EnterpriseSidebarItem extends Component {
  constructor(props) {
    super(props);
    this.class = props.customClass || 'enterprise-sidebar-item-row';
  }

  static propTypes = {
    label: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    image: PropTypes.any,
    selected: PropTypes.bool,
    onSelected: PropTypes.func,
    onGenerateLink: PropTypes.func,
    customClass: PropTypes.string,
  };

  handleClick = (event) => {
    event.preventDefault();
    this.props.onSelected(this.props.id);
  };

  handleGenerateLink = () => {
    const { id, onGenerateLink } = this.props;
    return onGenerateLink && onGenerateLink(id);
  };

  render() {
    return (
      <div className={this.class}>
        <a
          href={this.handleGenerateLink()}
          className={
            'sidebar-item-cell' + (this.props.selected ? ' selected' : '')
          }
          onClick={this.handleClick}
        >
          <div className="icon">
            {this.props.image && <img src={this.props.image} alt="icon" />}
          </div>
          <span className={this.props.selected ? 'selected' : ''}>
            {this.props.label}
          </span>
        </a>
      </div>
    );
  }
}

export default EnterpriseSidebarItem;
